import { ReactElement } from 'react';

import { createTranslatedText } from '@dreryk/react-common';
import { Link } from '@dreryk/react-components';

const HOTLINE_NUMBER = '(+48) 12 380 08 84';

export const MfaRequiredHotlineLink = (): ReactElement => {
   return (
      <Link
         testId={'callHotline'}
         block={false}
         href={`tel:${HOTLINE_NUMBER.replace(/[()\s]/gu, '')}`}
         label={createTranslatedText(HOTLINE_NUMBER)}
      />
   );
};
